import { getGlobalCallosumApi, } from '@thoughtspot/callosum-api';
import { assign } from '@thoughtspot/string-util';
export var BlobType;
(function (BlobType) {
    BlobType[BlobType["FONT_WOFF"] = 0] = "FONT_WOFF";
    BlobType[BlobType["IMAGE_JPEG"] = 1] = "IMAGE_JPEG";
    BlobType[BlobType["IMAGE_PNG"] = 2] = "IMAGE_PNG";
    BlobType[BlobType["IMAGE"] = 3] = "IMAGE";
    BlobType[BlobType["CSV"] = 4] = "CSV";
})(BlobType || (BlobType = {}));
export class GetBlobService {
    static getBlobUrl(blobGuid) {
        return assign(GetBlobService.BLOB_URL_PATTERN, {
            blobGuid,
        });
    }
    static getFileHeadersForCategory(category) {
        const params = {
            method: 'GET',
            path: `/file/getheaders/${category}`,
            isIgnorableRequest: false,
        };
        return getGlobalCallosumApi()
            ? getGlobalCallosumApi().execute(params)
            : null;
    }
}
GetBlobService.BLOB_URL_PATTERN = '/callosum/v1/file/getfile/{blobGuid}';
//# sourceMappingURL=get-blob-service.js.map